import { mount } from 'pele';
import type { Explanation } from '@pen/shared';
import DeckEngine from '@pen/shared/deck-engine.js';
import { toDeckSpec } from '@pen/shared/explanation';

export interface VisualHandle { readonly stepCount: number; go(index: number): void; destroy(): void }
/** Each adapter owns only host children, supports every valid spec of its declared kind,
 * clamps step navigation, and has idempotent cleanup. No timers survive destroy().
 */
export interface VisualRenderer<K extends Explanation['kind']> {
  readonly kind: K;
  mount(host: HTMLElement, content: Extract<Explanation, { kind: K }>): VisualHandle;
}
export const diagramRenderer: VisualRenderer<'diagram'> = {
  kind: 'diagram',
  mount(host, content) {
    const diagram = mount(host, content.source, { links: false, images: false, zoom: 'auto' });
    let disposed = false;
    return { stepCount: 1, go() {}, destroy() { if (!disposed) { disposed = true; diagram.destroy(); host.replaceChildren(); } } };
  },
};
export const deckRenderer: VisualRenderer<'deck'> = {
  kind: 'deck',
  mount(host, content) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 160 90');svg.setAttribute('role', 'img');svg.setAttribute('aria-label', content.title);host.replaceChildren(svg);
    const player = new DeckEngine.Player(svg, toDeckSpec(content));
    player.show(0);let disposed = false;
    return { stepCount: content.steps.length, go(index) { if (disposed) return;const i = Math.max(0, Math.min(content.steps.length - 1, Math.trunc(index) || 0));if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) player.show(i);else player.go(i); }, destroy() { if (!disposed) { disposed = true; player.stop(); host.replaceChildren(); } } };
  },
};
